import PortfolioStock from '../../models/PortfolioStock'

class PortfolioStockConverter {
    static convert({ portfolioId, stockId, note, addedDate, stockDateTimeSnapshot, buyLots, sellLots, statistics, companyName, symbol, currency }) {
        return new PortfolioStock({ portfolioId, stockId, note, addedDate, stockDateTimeSnapshot, buyLots, sellLots, statistics, companyName, symbol, currency })
    }
}

export default PortfolioStockConverter